// extracted by mini-css-extract-plugin
export default {"container":"PermissionMessage_container__dLro5"};